import { render, staticRenderFns } from "./RequestDetail.vue?vue&type=template&id=40fae852&"
import script from "./RequestDetail.vue?vue&type=script&lang=ts&"
export * from "./RequestDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports